import MuiDialog from "@mui/material/Dialog";
const Dialog = MuiDialog;
export default Dialog;
